<form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
  <!-- Identité -->
  <section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <h2 class="mb-4 text-sm font-semibold text-gray-800 dark:text-white/90">Identité</h2>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div>
        <label for="firstName" class="mb-1.5 block text-xs font-medium text-gray-700 dark:text-gray-400">
          Prénom <span class="text-error-500">*</span>
        </label>
        <input
          id="firstName"
          type="text"
          formControlName="firstName"
          autocomplete="given-name"
          class="h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
          [class.border-error-500]="showError('firstName')"
          [class.border-gray-300]="!showError('firstName')"
          [class.dark:border-gray-700]="!showError('firstName')"
        />
        @if (errorFor('firstName'); as msg) {
          <p class="mt-1.5 text-xs text-error-500">{{ msg }}</p>
        }
      </div>

      <div>
        <label for="lastName" class="mb-1.5 block text-xs font-medium text-gray-700 dark:text-gray-400">
          Nom <span class="text-error-500">*</span>
        </label>
        <input
          id="lastName"
          type="text"
          formControlName="lastName"
          autocomplete="family-name"
          class="h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
          [class.border-error-500]="showError('lastName')"
          [class.border-gray-300]="!showError('lastName')"
          [class.dark:border-gray-700]="!showError('lastName')"
        />
        @if (errorFor('lastName'); as msg) {
          <p class="mt-1.5 text-xs text-error-500">{{ msg }}</p>
        }
      </div>

      <div>
        <label class="mb-1.5 block text-xs font-medium text-gray-700 dark:text-gray-400">Sexe</label>
        <app-pretty-select
          formControlName="sex"
          [options]="sexOptions"
          placeholder="Non précisé"
        />
      </div>

      <div>
        <label for="username" class="mb-1.5 block text-xs font-medium text-gray-700 dark:text-gray-400">
          Identifiant <span class="text-error-500">*</span>
        </label>
        <input
          id="username"
          type="text"
          formControlName="username"
          autocomplete="username"
          placeholder="prenom.nom"
          class="h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
          [class.border-error-500]="showError('username')"
          [class.border-gray-300]="!showError('username')"
          [class.dark:border-gray-700]="!showError('username')"
        />
        @if (errorFor('username'); as msg) {
          <p class="mt-1.5 text-xs text-error-500">{{ msg }}</p>
        }
      </div>
    </div>
  </section>

  <!-- Contact -->
  <section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <h2 class="mb-4 text-sm font-semibold text-gray-800 dark:text-white/90">Contact</h2>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div>
        <label for="email" class="mb-1.5 block text-xs font-medium text-gray-700 dark:text-gray-400">
          Email <span class="text-error-500">*</span>
        </label>
        <input
          id="email"
          type="email"
          formControlName="email"
          autocomplete="email"
          placeholder="utilisateur@exemple.com"
          class="h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
          [class.border-error-500]="showError('email')"
          [class.border-gray-300]="!showError('email')"
          [class.dark:border-gray-700]="!showError('email')"
        />
        @if (errorFor('email'); as msg) {
          <p class="mt-1.5 text-xs text-error-500">{{ msg }}</p>
        }
      </div>

      <div>
        <label for="phone" class="mb-1.5 block text-xs font-medium text-gray-700 dark:text-gray-400">
          Téléphone <span class="text-error-500">*</span>
        </label>
        <input
          id="phone"
          type="tel"
          formControlName="phone"
          autocomplete="tel"
          placeholder="771112233"
          class="h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
          [class.border-error-500]="showError('phone')"
          [class.border-gray-300]="!showError('phone')"
          [class.dark:border-gray-700]="!showError('phone')"
        />
        @if (errorFor('phone'); as msg) {
          <p class="mt-1.5 text-xs text-error-500">{{ msg }}</p>
        }
      </div>

      <div class="sm:col-span-2">
        <label for="address" class="mb-1.5 block text-xs font-medium text-gray-700 dark:text-gray-400">Adresse</label>
        <input
          id="address"
          type="text"
          formControlName="address"
          autocomplete="street-address"
          placeholder="Dakar Plateau"
          class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
        />
        @if (errorFor('address'); as msg) {
          <p class="mt-1.5 text-xs text-error-500">{{ msg }}</p>
        }
      </div>
    </div>
  </section>

  <!-- Sécurité -->
  <section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <h2 class="mb-1 text-sm font-semibold text-gray-800 dark:text-white/90">
      @if (mode === 'create') { Mot de passe } @else { Réinitialiser le mot de passe }
    </h2>
    <p class="mb-4 text-xs text-gray-500 dark:text-gray-400">
      @if (mode === 'create') {
        Sera communiqué à l'utilisateur lors de sa première connexion. Il devra le changer ensuite.
      } @else {
        Laissez vide pour ne pas changer le mot de passe. Sinon, le nouveau remplacera l'ancien.
      }
    </p>
    <div>
      <label for="plainPassword" class="mb-1.5 block text-xs font-medium text-gray-700 dark:text-gray-400">
        Mot de passe
        @if (mode === 'create') { <span class="text-error-500">*</span> }
      </label>
      <div class="relative">
        <input
          id="plainPassword"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="plainPassword"
          autocomplete="new-password"
          class="h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 pr-11 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
          [class.border-error-500]="showError('plainPassword')"
          [class.border-gray-300]="!showError('plainPassword')"
          [class.dark:border-gray-700]="!showError('plainPassword')"
        />
        <button
          type="button"
          (click)="togglePassword()"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-brand-600 hover:text-brand-700 dark:text-brand-400"
        >
          @if (showPassword) { Masquer } @else { Afficher }
        </button>
      </div>
      @if (errorFor('plainPassword'); as msg) {
        <p class="mt-1.5 text-xs text-error-500">{{ msg }}</p>
      }
    </div>
  </section>

  <!-- Statut -->
  <section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <h2 class="mb-1 text-sm font-semibold text-gray-800 dark:text-white/90">Statut</h2>
    <p class="mb-4 text-xs text-gray-500 dark:text-gray-400">
      Un compte inactif ne peut pas se connecter à la plateforme.
    </p>
    <label class="inline-flex cursor-pointer items-center gap-3">
      <input type="checkbox" formControlName="active" class="peer sr-only" />
      <span class="relative h-6 w-11 rounded-full bg-gray-200 transition peer-checked:bg-brand-500 dark:bg-gray-700">
        <span class="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow-theme-xs transition peer-checked:translate-x-5"></span>
      </span>
      <span class="text-sm text-gray-700 dark:text-gray-300">
        @if (form.controls.active.value) { Actif } @else { Inactif }
      </span>
    </label>
  </section>

  <!-- Server error -->
  @if (serverError) {
    <div class="rounded-lg border border-error-200 bg-error-50 px-4 py-3 text-sm text-error-700 dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
      {{ serverError }}
    </div>
  }

  <!-- Actions -->
  <div class="flex flex-col-reverse items-stretch gap-3 sm:flex-row sm:items-center sm:justify-end">
    <button
      type="button"
      (click)="onCancel()"
      [disabled]="submitting"
      class="rounded-lg border border-gray-300 px-5 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
    >
      Annuler
    </button>
    <button
      type="submit"
      [disabled]="submitting || form.invalid"
      class="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-500 px-5 py-2.5 text-sm font-medium text-white shadow-theme-xs transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:bg-brand-300"
    >
      @if (submitting) {
        <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-opacity="0.25" />
          <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
        </svg>
        Enregistrement…
      } @else {
        @if (mode === 'create') { Créer l'utilisateur } @else { Enregistrer les modifications }
      }
    </button>
  </div>
</form>
